module.exports = __webpack_public_path__ + "static/media/039.fa55c150.jpg";